const defaultState = {
  trainingsData: {},
  trainingSections: [],
  trainingDetail: {},
  tutorialsData: [],
  tutorialsDetail: {},
  growthMaterial: [],
  growthMaterialDetail: {},
  mockupLibrary: [],
  mockupLibraryMeta: null,
  updates: [],
};

const educationReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "setTrainingsData":
      return {
        ...state,
        trainingsData: action.payload || {},
      };

    case "setTrainingSections":
      return {
        ...state,
        trainingSections: action.payload,
      };
    case "setTrainingsDetail":
      return {
        ...state,
        trainingDetail: action.payload,
      };

    case "setTutorialsData":
      return {
        ...state,
        tutorialsData: action.payload,
      };

    case "setTutorialsDetail":
      return {
        ...state,
        tutorialsDetail: action.payload,
      };

    case "setUpdates":
      return {
        ...state,
        updates: action.payload,
      };

    case "setGrowthMaterial":
      return {
        ...state,
        growthMaterial: action.payload,
      };

    case "setGrowthMaterialDetail":
      return {
        ...state,
        growthMaterialDetail: action.payload,
      };

    case "setMockupLibrary":
      return {
        ...state,
        mockupLibrary: action.payload,
      };

    case "setMockupLibraryMeta":
      return {
        ...state,
        mockupLibraryMeta: action.payload,
      };

    default:
      return state;
  }
};

export default educationReducer;
